import {
  CHAR_LIMIT_MESSAGE,
  COMMENTS_REQUIRED,
  EMPLOYEE_ID_REQUIRED,
  END_DATE_BEFORE_START_DATE_ERROR,
  END_DATE_IS_REQUIRED,
  INVALID_EMPLOYEE_ID,
  START_DATE_AFTER_END_DATE_ERROR,
  START_DATE_IS_REQUIRED,
} from "../../util/messageConstants";
import { areAllDaysOff, areAnyDaysLeftBlank, isBaseScheduleBlank } from "../temporaryAssignmentInputValidation";
import { ADMIN_SELF_SCHEDULE_EDIT_ERROR, FREEFORM_REASON_CHAR_LIMIT } from "./scheduleConstants";

export function validateScheduleEmployeeId(input, userId) {
  if (input.trim() === "") {
    return EMPLOYEE_ID_REQUIRED;
  } else if (input.trim().charAt(0).toUpperCase() !== "E") {
    return INVALID_EMPLOYEE_ID + ' - start with "e"';
  } else if (!input.match("e\\d{0,6}$")) {
    return INVALID_EMPLOYEE_ID;
  } else if (userId === input) {
    return ADMIN_SELF_SCHEDULE_EDIT_ERROR;
  }
  return "";
}

export function validateEmployeeDataForAdminSchedule(input, selectedStation) {
  if (input === null) {
    return "Not loaded";
  }

  if (!input.isActive) {
    return INVALID_EMPLOYEE_ID;
  }
  if (
    input.activeStation !== selectedStation &&
    input.homeStation !== selectedStation &&
    input?.tempStation !== selectedStation
  ) {
    return "Employee must work or actively temp in " + selectedStation;
  }
  return "";
}

export const validateBaseScheduleComments = (inputComments) => {
  if (inputComments === "") {
    return COMMENTS_REQUIRED;
  }
  if (inputComments.length > FREEFORM_REASON_CHAR_LIMIT) {
    return CHAR_LIMIT_MESSAGE(FREEFORM_REASON_CHAR_LIMIT);
  }
  return "";
};

export const validateBaseScheduleStartDate = (startDate, endDate) => {
  if (startDate === null) {
    return START_DATE_IS_REQUIRED;
  }

  if (endDate === null) {
    return "";
  }

  if (startDate.toMillis() > endDate.toMillis()) {
    return START_DATE_AFTER_END_DATE_ERROR;
  }

  return "";
};

export const validateBaseScheduleEndDate = (startDate, endDate) => {
  if (endDate === null) {
    return END_DATE_IS_REQUIRED;
  }

  if (startDate === null) {
    return "";
  }

  if (endDate.toMillis() < startDate.toMillis()) {
    return END_DATE_BEFORE_START_DATE_ERROR;
  }

  return "";
};

export const validateNoPartialSchedules = (baseSchedule) => {
  if (isBaseScheduleBlank(baseSchedule)) {
    return "Cannot enter a blank schedule";
  } else if (areAnyDaysLeftBlank(baseSchedule)) {
    return "Cannot enter a partial schedule";
  } else if (areAllDaysOff(baseSchedule)) {
    return "Cannot enter a schedule with all days off";
  }
  return "";
};
